// LEGACY: Uses SCSS with CSS modules. New code should use @metarouter-private/mr-mui components instead.
import React, { useState } from 'react';

import pt from 'prop-types';

import s from './index.module.scss';
import Row from './row';
import cx from 'classnames';
import Depth from './depth';
import { Box, Button, Stack, Typography } from '@metarouter-private/mr-mui';
import { getAllRowKeys, getRowKey } from 'app/event-monitoring/event-schemas/panel/tree/rowUtils';

const UI_EXPAND_ALL_KEY = '__mr_ui_expand_all';

const renderRows = (properties, depth, openProps, setOpenProps, parent = '') => {
  return Object.entries(properties).reduce((result, [property, values]) => {
    // const key = parent + property + depth;
    const key = getRowKey(property, depth, parent);

    const toggleOpen = () => {
      setOpenProps(prevOpenProps => {
        const currentOpenState = Boolean(prevOpenProps[key]);

        return {
          ...prevOpenProps,
          [key]: !currentOpenState,
        };
      });
    };

    result.push(
      <Row
        key={key}
        depth={depth}
        property={property}
        isOpen={openProps[key]}
        setIsOpen={toggleOpen}
        properties={values.properties || values.items}
        {...values}
      />
    );

    if (values.properties && openProps[key]) {
      result.push(...renderRows(values.properties, depth + 1, openProps, setOpenProps, property));
    }

    if (values.items && openProps[key]) {
      result.push(
        <div key={key + 'array'} className={cx(s.array, Depth[depth + 1])}>
          <div className={s.text}>Schema of the first array item</div>
          {renderRows(values.items, 1, openProps, setOpenProps, property)}
        </div>
      );
    }

    return result;
  }, []);
};

const SchemaTree = ({ properties }) => {
  const [openProps, setOpenProps] = useState({
    [UI_EXPAND_ALL_KEY]: false,
  });

  const handleExpandCollapseAll = () => {
    setOpenProps(prevOpenProps => {
      const newOpenProps = { ...prevOpenProps };

      const toggleExpandAll = !prevOpenProps[UI_EXPAND_ALL_KEY];
      newOpenProps[UI_EXPAND_ALL_KEY] = toggleExpandAll;

      const allKeys = getAllRowKeys(properties, 0);
      allKeys.forEach(key => {
        newOpenProps[key] = toggleExpandAll;
      });

      return newOpenProps;
    });
  };

  const expandButonText = openProps[UI_EXPAND_ALL_KEY] ? 'Collapse All' : 'Expand All';

  return (
    <Box>
      <Stack direction="row" alignItems="center" justifyContent="space-between" my={2}>
        <Typography variant="h5" component="h3">
          Schema Tree
        </Typography>
        <Button variant="outlined" color="secondary" onClick={handleExpandCollapseAll}>
          {expandButonText}
        </Button>
      </Stack>
      <Box className={s.list}>{renderRows(properties, 0, openProps, setOpenProps)}</Box>
    </Box>
  );
};

SchemaTree.propTypes = {
  properties: pt.object, // Todo better define
};

export default SchemaTree;
